class HeaderDrawer extends SideDrawer {
  constructor() {
    super();
    this.moved = true;
    this.header = this.header || document.querySelector('.header-wrapper');
  }

  open(triggeredBy) {
    if (this.header) {
      this.header.classList.add('open-header-drawer');
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom)}px`);
    }
    window.addEventListener('resize', this.onResize);
    super.open(triggeredBy);
  }

  close() {
    super.close();
    if (this.header) {
      this.header.classList.remove('open-header-drawer');
      document.documentElement.style.removeProperty('--header-bottom-position');
    }
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

if (!customElements.get('menu-details')) {
  customElements.define('menu-details',
    class MenuDetails extends HTMLElement {
      constructor() {
        super();
        this.summary.addEventListener('click', this.onSummaryClick.bind(this));
        this.button.addEventListener('click', this.onButtonClick.bind(this));
      }

      get parent() {
        return this.closest('[data-menu-details-parent]');
      }

      get detailsContainer() {
        return this.querySelector('details');
      }

      get summary() {
        return this.querySelector('summary');
      }

      get button() {
        return this.querySelector('button');
      }

      onSummaryClick(e) {
          e.preventDefault(); // Prevent default toggle behavior

          const isOpen = this.detailsContainer.hasAttribute('open');

          if (isOpen) {
              this.parent.classList.remove('active');
              this.classList.remove('active');
              this.detailsContainer.removeAttribute('open');
              this.summary.setAttribute('aria-expanded', false);
              this.closeAnimation();
          } else {
              this.detailsContainer.setAttribute('open', true);
              this.summary.setAttribute('aria-expanded', true);

              // Slight delay for smoother transition (CSS animations trigger better)
              setTimeout(() => {
                  this.parent.classList.add('active');
                  this.classList.add('active');
              }, 100); // Delay in ms — adjust if needed
          }
      }

      onButtonClick() {
        this.parent.classList.remove('active');
        this.classList.remove('active');
        this.detailsContainer.removeAttribute('open');
        this.summary.setAttribute('aria-expanded', false);
        this.closeAnimation();
      }

      closeAnimation() {
        let animationStart;
        const handleAnimation = (time) => {
          if (animationStart === undefined) animationStart = time;
          const elapsedTime = time - animationStart;
          if (elapsedTime < 400) {
            window.requestAnimationFrame(handleAnimation);
          } else {
            this.removeAttribute('open');
          }
        }
        window.requestAnimationFrame(handleAnimation);
      }
    }
  )
}